
import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What\'s included in the funnel design?',
      answer: 'Each funnel includes landing page design, thank you pages, email sequences, mobile optimization, basic integrations, and analytics setup. Higher tier plans include additional pages, advanced integrations, and ongoing optimization.'
    },
    {
      question: 'How long does it take to complete my funnel?',
      answer: 'Delivery times vary by plan: Starter (2 weeks), Professional (1 week), Enterprise (5 days). Rush delivery is available for an additional fee if you need it faster.'
    },
    {
      question: 'What if I need revisions?',
      answer: 'Starter plan includes 3 revisions, while Professional and Enterprise plans include unlimited revisions until you\'re completely satisfied with the result.'
    },
    {
      question: 'Do you work with all funnel platforms?',
      answer: 'Yes, we work with ClickFunnels, GoHighLevel, Leadpages, Unbounce, and most major funnel building platforms. We\'ll recommend the best platform for your specific needs.'
    },
    {
      question: 'Is there ongoing support after delivery?',
      answer: 'All plans include 30 days of free support after delivery. Enterprise clients get ongoing monthly optimization and dedicated account management.'
    },
    {
      question: 'What if I\'m not satisfied with the results?',
      answer: 'We offer a 30-day money-back guarantee. If you\'re not completely satisfied with your funnel, we\'ll refund your investment in full.'
    },
    {
      question: 'Can I upgrade my plan later?',
      answer: 'Absolutely! You can upgrade to a higher plan at any time and we\'ll credit what you\'ve already paid toward the new plan.'
    },
    {
      question: 'Do you provide training on how to use the funnel?',
      answer: 'Yes, all plans include basic training materials. Professional and Enterprise plans include additional training sessions and documentation.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Get answers to common questions about our funnel services
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-sm overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="font-semibold text-gray-900 pr-4">{faq.question}</span>
                <i className={`ri-arrow-down-s-line text-2xl text-gray-400 transition-transform duration-200 flex-shrink-0 ${
                  openIndex === index ? 'transform rotate-180' : ''
                }`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">Still have questions?</p>
          <a 
            href="mailto:hello@cofunnels.com" 
            className="inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold cursor-pointer"
          >
            <i className="ri-mail-line mr-2"></i>
            Contact us directly
          </a>
        </div>
      </div>
    </section>
  );
}